import { pm2ConfigStore } from '@pm2/store';
import { Link } from '@provider/navigation';
import { Chevron } from '@utils/react';
import { linkCls, labelCls, rightContainerCls, countCls, chevronCls } from './atom.go-to-search-item.style.js';
import { itemCls } from './atom.result-item.style.js';
import { jsx, jsxs } from 'react/jsx-runtime';

function GoToSearchItem({
  id,
  query,
  count,
  selected,
  closeSearch
}) {
  const searchPath = pm2ConfigStore.useSelector(state => state.config.searchPath);
  return /*#__PURE__*/jsx("li", {
    className: itemCls,
    role: "option",
    id: id,
    "aria-selected": selected,
    children: /*#__PURE__*/jsxs(Link, {
      href: `${searchPath}?q=${encodeURIComponent(query)}`,
      className: linkCls,
      onClick: closeSearch,
      children: [/*#__PURE__*/jsx("p", {
        className: labelCls,
        children: "Se alle resultater"
      }), /*#__PURE__*/jsxs("div", {
        className: rightContainerCls,
        children: [/*#__PURE__*/jsx("span", {
          className: countCls,
          children: count
        }), /*#__PURE__*/jsx(Chevron, {
          size: 10,
          className: chevronCls
        })]
      })]
    })
  });
}

export { GoToSearchItem };
//# sourceMappingURL=atom.go-to-search-item.js.map
